import { useEffect, useLayoutEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import useMedia from "use-media";
import { useRtoaster } from "../../../hooks/useRtoaster";
import thanks_logo from '../../../resources_membership_hotel/image/thanks_logo.gif';
import MessageConst from '../../../const/messageConst';
import { Button } from "../../atoms/button";
import { Label } from '../../atoms/label';
import { BreadCrumb } from '../../molecules/breadCrumb';
import { ErrorMassage } from "../../molecules/errorMassage";
import { RoomInputList } from "../../molecules/roomInputList";
import { MembershipFooterContainer } from '../common/membershipFooterContainer';
import common from "../../../resources/js/common/common";
import { MealInputList } from "../../molecules/mealInputList";
import './../../../resources_membership_hotel/css/hotel/inputUser.css';
import { apiKeyCheck, changeReserve, getPropertyList, planTotalPrice, registSaveHomeFlInfo, setReserve, versionGetApi } from "../../../const";
import commonUtil from "../../../common/commonUtil";
import Const from "../../../const/Const";

const human = [
    { id: "0", value: "0", selected: true },
    { id: "1", value: "1", selected: false },
    { id: "2", value: "2", selected: false },
    { id: "3", value: "3", selected: false },
];
// テスト用仮定数
const propertyInfo = {
    customerGender: [
        { text: "男性", value: "01" },
        { text: "女性", value: "02" },
    ]
};

const MembershipConfirmUserContainer = (props) => {
    const {
        state,
        login,
        checkIn,
        checkOut,
        mealInfoList,
        setMealInfoList,
        otherMenuInfoList,
        setOtherMenuInfoList,
        membershipSearchParam,
        setMembershipSearchParam,
        membershipReserveInfo,
        setMembershipReserveInfo,
        inputUserInfo,
        setInputUserInfo,
        right,
        membershipPlanInfo,
        setMembershipPlanInfo,
        // propertyInfo,
        setPropertyInfo,
        setPopupData,
        setPopupMessage,
        onClickOpenPopupWindow,
        setMembershipReserveComf
    } = props;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);

    const history = useHistory();
    const store = useStore();
    const loginUserInfo = store.getState().login.loginUserInfo;
    const [jikantaiKbnList, setJikantaiKbnList] = useState([]);
    const [linkList, setLinkList] = useState([]);
    const [roomTypeList, setRoomTypeList] = useState([]);
    const [totalPrice, setTotalPrice] = useState({
        totalPlanPrice: 0,
        planName: "",
        targetList: [],
        courseList: [],
        dinnerList: [],
        breakfastList: []
    });

    const loginType = login.loginType;
    const isCrawl = loginType === 'CRAWL';
    const crawlMember = store.getState().crawlMember;

    /** CRAWL用ユーザー情報設定 */
    const userInfo = isCrawl && crawlMember ?
        {
            syainNo: crawlMember.syain_no,
            uketukeCd: crawlMember.uketuke_cd,
            uketukeBashoCd: crawlMember.uketukebasyo_cd,
        } : null;

    // エラー情報
    const [errorInfo, setErrorInfo] = useState({ errorMessage: null, errorFlg: false, });
    const [flgList, setFlgList] = useState(false);

    const [illegalFlg, setIllegalFlg] = useState(false);
    let clickFlg = true;

    // rtoasterタグ生成
    const customParam = {
        "riyosyodat": membershipSearchParam.checkInDate,
        "sisetucd": membershipReserveInfo.shisetsuCd,
        "packcd": membershipReserveInfo.planCd,
        "packnam": membershipReserveInfo.planName,
        "keiyakuno": membershipSearchParam.keiyakuNo,
        "restaurantcd2": mealInfoList?.filter(value => value.jikantaiKbn == "2")?.map(value => value.restaurantCd)?.join(","),
        "restaurantcd3": mealInfoList?.filter(value => value.jikantaiKbn == "3")?.map(value => value.restaurantCd)?.join(","),
        "hakusu": membershipSearchParam.nights,
        "nonstopcheckinflg": inputUserInfo.smartCheckInFlg,
        "nonstopcheckoutflg": inputUserInfo.smartCheckOutFlg,
    }
    useRtoaster(history.location.pathname, customParam);

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
        if (apiKey === null) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
        if (apiKey) {
            common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    useEffect(() => {
        common.doPost(versionGetApi, {}, afterVerCheck);
        if (membershipReserveInfo.changeFlg) {
            if (loginType === 'MEMBER') {
                if (inputUserInfo.selectRightFlg) {
                    setLinkList([
                        { path: "/reserve/top", label: "HOME" },
                        { path: "/reserve/hotel/search", label: "ホテル予約" },
                        { path: "/reserve/hotel/hotelBookingConfirmDetail", label: "予約内容確認" },
                        { path: "/reserve/hotel/inputUser", label: "お客様情報入力", state: { locationInfo: history.location } },
                        { path: "/reserve/hotel/chooseRight", label: "使用する権利消化を選択" },
                    ]);
                } else {
                    setLinkList([
                        { path: "/reserve/top", label: "HOME" },
                        { path: "/reserve/hotel/search", label: "ホテル予約" },
                        { path: "/reserve/hotel/hotelBookingConfirmDetail", label: "予約内容確認" },
                        { path: "/reserve/hotel/inputUser", label: "お客様情報入力", state: { locationInfo: history.location } },
                    ]);
                }
            } else if (loginType === 'CRAWL') {
                if (inputUserInfo.selectRightFlg) {
                    setLinkList([
                        { path: "/reserve/hotel/crawlSearch", label: "ホテル予約" },
                        { path: "/reserve/hotel/hotelBookingConfirmDetail", label: "予約内容確認" },
                        { path: "/reserve/hotel/inputUser", label: "お客様情報入力", state: { locationInfo: history.location } },
                        { path: "/reserve/hotel/chooseRight", label: "使用する権利消化を選択" },
                    ]);
                } else {
                    setLinkList([
                        { path: "/reserve/hotel/crawlSearch", label: "ホテル予約" },
                        { path: "/reserve/hotel/hotelBookingConfirmDetail", label: "予約内容確認" },
                        { path: "/reserve/hotel/inputUser", label: "お客様情報入力", state: { locationInfo: history.location } },
                    ]);
                }
            }
        } else {
            if (loginType === 'MEMBER') {
                if (inputUserInfo.selectRightFlg) {
                    setLinkList([
                        { path: "/reserve/top", label: "HOME" },
                        { path: "/reserve/hotel/search", label: "ホテル予約" },
                        { path: "/reserve/hotel/searchResult", label: "検索結果" },
                        { path: "/reserve/hotel/inputUser", label: "お客様情報入力", state: { locationInfo: history.location } },
                        { path: "/reserve/hotel/chooseRight", label: "使用する権利消化を選択" },
                    ]);
                } else {
                    setLinkList([
                        { path: "/reserve/top", label: "HOME" },
                        { path: "/reserve/hotel/search", label: "ホテル予約" },
                        { path: "/reserve/hotel/searchResult", label: "検索結果" },
                        { path: "/reserve/hotel/inputUser", label: "お客様情報入力", state: { locationInfo: history.location } },
                    ]);
                }
            } else if (loginType === 'CRAWL') {
                if (inputUserInfo.selectRightFlg) {
                    setLinkList([
                        { path: "/reserve/hotel/crawlSearch", label: "ホテル予約" },
                        { path: "/reserve/hotel/searchResult", label: "検索結果" },
                        { path: "/reserve/hotel/inputUser", label: "お客様情報入力", state: { locationInfo: history.location } },
                        { path: "/reserve/hotel/chooseRight", label: "使用する権利消化を選択" },
                    ]);
                } else {
                    setLinkList([
                        { path: "/reserve/hotel/crawlSearch", label: "ホテル予約" },
                        { path: "/reserve/hotel/searchResult", label: "検索結果" },
                        { path: "/reserve/hotel/inputUser", label: "お客様情報入力", state: { locationInfo: history.location } },
                    ]);
                }
            }
        }
        window.scroll({ top: 0, behavior: 'smooth' })
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
        if (commonUtil.checkIllegalAccess(membershipReserveInfo, membershipSearchParam)) {
            setIllegalFlg(true)
        } else {
            // プロパティ一覧取得
            common.doPost(getPropertyList, { propertyTypeList: ["SPAN_TIME"] }, afterGetPropertyList);
            const req = {
                honkanShisetsuCd: membershipReserveInfo.honkanShisetsuCd,
                shisetsuCd: membershipReserveInfo.shisetsuCd,
                riyoDate: membershipSearchParam.checkInDate,
                hakuCnt: membershipSearchParam.nights,
                planShohinCd: membershipReserveInfo.planShohinCd,
                planCd: membershipReserveInfo.planCd,
                roomList: inputUserInfo.roomList,
                foodCourseList: inputUserInfo.foodCourseList,
            }
            common.doPost(planTotalPrice, req, afterPlanTotalPrice);
        }
    }, [useMediaFlag]);

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    // プロパティ一覧取得後処理
    const afterGetPropertyList = (res) => {
        let data = res.data;
        let dataList = [];
        if (data.resultCode == 0) {
            if (data.propertyList && data.propertyList.length != 0) {
                let propertyList = data.propertyList;
                propertyList.map(value => {
                    switch (value.propertyType) {
                        // 時間帯区分
                        case "SPAN_TIME":
                            value.propertyList.map(property => {
                                dataList.push({ jikantaiKbn: property.apiCallValue, jikantai: property.propertyName });
                            })
                            setJikantaiKbnList(dataList);
                            break;
                        default:
                            break;
                    }
                })
            }
        } else {
            // エラー処理
        }
    }

    // 予約プラン料金取得処理後処理
    const afterPlanTotalPrice = (res) => {
        let data = res.data;
        if (data.resultCode == 0) {
            // プラン料金
            const targetList = []
            if (data.roomPriceListTotal && data.roomPriceListTotal.length > 0) {
                data.roomPriceListTotal.forEach(roomPriceTotal => {
                    const roomPriceListTotal = []
                    roomPriceTotal.roomPriceListDay.forEach(roomPriceDay => {
                        const roomPriceList = []
                        if (roomPriceDay.menCnt + roomPriceDay.womenCnt > 0) {
                            roomPriceList.push({
                                target: '大人',
                                cnt: roomPriceDay.menCnt + roomPriceDay.womenCnt,
                                price: roomPriceDay.priceAdult
                            })
                        }
                        if (roomPriceDay.childCnt > 0) {
                            roomPriceList.push({
                                target: '小学生',
                                cnt: roomPriceDay.childCnt,
                                price: roomPriceDay.priceChild
                            })
                        }
                        if (roomPriceDay.preschoolerCnt > 0) {
                            roomPriceList.push({
                                target: '幼児',
                                cnt: roomPriceDay.preschoolerCnt,
                                price: roomPriceDay.pricePreschooler
                            })
                        }
                        if (roomPriceDay.babyCnt > 0) {
                            roomPriceList.push({
                                target: '乳児',
                                cnt: roomPriceDay.babyCnt,
                                price: roomPriceDay.priceBaby
                            })
                        }
                        roomPriceListTotal.push({ roomSeq: roomPriceDay.roomSeq, roomPriceList: roomPriceList })
                    })
                    targetList.push({ stayNum: roomPriceTotal.stayNum, roomPriceListTotal: roomPriceListTotal })
                })
            }
            // // コース料金
            // const dinnerList = []
            // const breakfastList = []
            // const courseList = []
            // if (data.foodCourseList && data.foodCourseList.length > 0) {
            //     data.foodCourseList.forEach((course, courseIndex) => {
            //         const isDinner = course.jikantaiKbn == (jikantaiKbnList.find(jikantaiInfo => jikantaiInfo.jikantai == "夕") ? jikantaiKbnList.find(jikantaiInfo => jikantaiInfo.jikantai == "夕").jikantaiKbn : "2")
            //         if (isDinner) {
            //             dinnerList.push((
            //                 <Label className="confirmContentLabel" label={`${course.foodCourseName}:\\${course.priceCourse.toLocaleString()} × ${course.targetCnt}`}/>
            //             ))
            //         } else {
            //             breakfastList.push((
            //                 <Label className="confirmContentLabel" label={`${course.foodCourseName}:\\${course.priceCourse.toLocaleString()} × ${course.targetCnt}}`}/>
            //             ))
            //         }
            //         courseList.push(
            //             <Label className="confirmContentLabel" label={`${course.foodCourseName}:\\${course.priceCourse.toLocaleString()} × ${course.targetCnt} = \\${course.priceTotalCourse.toLocaleString()}`}/>
            //         )
            //     })
            // }
            setTotalPrice({
                totalPlanPrice: data.totalPlanPrice,
                totalRoomPrice: data.totalRoomPrice,
                planCategoryDetailCd: data.planCategoryDetailCd,
                totalDiscountPrice: data.totalDiscountPrice,
                discountNum: data.discountNum,
                totalCouponPrice: data.totalCouponPrice,
                totalFoodPrice: data.totalFoodPrice,
                holidayFlg: data.holidayFlg,
                targetList,
                roomPriceListType: data.roomPriceListType
            })
        } else {
            // エラー処理
        }
    }

    // 「戻る」ボタン押下時
    const onClickBack = () => {
        if (inputUserInfo.selectRightFlg) {
            history.push("/reserve/hotel/chooseRight");
        } else {
            history.push("/reserve/hotel/inputUser", { locationInfo: history.location });
        }
    }

    // 予約登録後処理
    const afterSetReserve = (res) => {
        let data = res.data;
        if (data.resultCode == 0) {
            setMembershipReserveComf({
                keiyakuNo: membershipSearchParam.keiyakuNo,
                checkInDate: membershipSearchParam.checkInDate,
                checkOutDate: membershipSearchParam.checkOutDate,
                hakuCnt: membershipSearchParam.nights,
                shisetsuName: membershipReserveInfo.shisetsuName,
                planName: membershipReserveInfo.planName,
                roomCnt: inputUserInfo.roomList.length,
                yoyakuNo: data.yoyakuNo,
                daihyouNameKana: inputUserInfo.daihyouNameKana,
                daihyouName: inputUserInfo.daihyouName,
                machiFlg: membershipReserveInfo.machiFlg
            })
            history.push("/reserve/hotel/reserveComplete");
        } else {
            setErrorInfo({ errorMessage: [data.errorMessage], errorFlg: true })
        }
    }
    // 「この内容で予約する」ボタン押下時
    const onClickReserve = () => {
        if (clickFlg) {
            clickFlg = false
            // 消化権利情報設定
            let reqShokaKenriList = [];
            right.forEach(senyu => {
                let reqSenyuDate = [];
                senyu.senyuDate.forEach(shoka => {
                    reqSenyuDate.push(shoka.shokaKenriDate);
                })
                reqShokaKenriList.push({ senyuDate: reqSenyuDate, siyoDate: senyu.siyoDate });
            })
            let req = {};
            if (membershipReserveInfo.changeFlg) {
                // リクエスト設定
                req = {
                    shisetsuCd: membershipReserveInfo.shisetsuCd,
                    yoyakuNo: membershipReserveInfo.yoyakuNo,
                    keiyakuNo: membershipSearchParam.keiyakuNo,
                    riyoKaiinkenSyubetCd: membershipSearchParam.riyoKaiinkenSyubetCd,
                    pointKaiinId: membershipSearchParam.memberCd,
                    riyoDate: membershipSearchParam.checkInDate,
                    hakuCnt: membershipSearchParam.nights,
                    planCd: membershipReserveInfo.planCd,
                    planShohinCd: membershipReserveInfo.planShohinCd,
                    planCategoryDetailCd: membershipReserveInfo.planCategoryDetailCd,
                    foodRequest: inputUserInfo.foodRequest,
                    allergyKbn: inputUserInfo.allergyKbn,
                    allergyBiko: inputUserInfo.allergyBiko,
                    applicantNameKana: inputUserInfo.applicantNameKana,
                    applicantName: inputUserInfo.applicantName,
                    daihyouNameKana: inputUserInfo.daihyouNameKana,
                    daihyouName: inputUserInfo.daihyouName,
                    mainPhoneKbn: inputUserInfo.mainPhoneKbn,
                    mainPhoneNumber: inputUserInfo.mainPhoneNumber,
                    contactPhoneNumber: inputUserInfo.contactPhoneNumber,
                    contactMailAddress: inputUserInfo.contactMailAddress,
                    relationCd: inputUserInfo.relationCd,
                    prefectureCd: inputUserInfo.prefectureCd,
                    prefecture: inputUserInfo.prefecture,
                    zipCode1: inputUserInfo.zipCode1,
                    zipCode2: inputUserInfo.zipCode2,
                    address1: inputUserInfo.address1,
                    address2: inputUserInfo.address2,
                    address3: inputUserInfo.address3,
                    transportCd: inputUserInfo.transportCd,
                    carCnt: inputUserInfo.carCnt,
                    busTime: inputUserInfo.busTime,
                    kozafurikaeFlg: inputUserInfo.kozafurikaeFlg,
                    smartCheckInFlg: inputUserInfo.smartCheckInFlg,
                    smartCheckOutFlg: inputUserInfo.smartCheckOutFlg,
                    nonstopCheckInFlg: inputUserInfo.nonstopCheckInFlg,
                    biko: inputUserInfo.biko,
                    kakuninMailKiboKbn: inputUserInfo.kakuninMailKiboKbn ? "1" : "0",
                    kakuninMailAddress: inputUserInfo.confirmReserveMail,
                    machiFlg: inputUserInfo.machiFlg,
                    roomList: inputUserInfo.roomList,
                    foodList: inputUserInfo.foodList,
                    foodCourseList: inputUserInfo.foodCourseList,
                    shokaKenriList: reqShokaKenriList,
                    dinnerTsukiFlg: membershipReserveInfo.dinnerTsukiPlanFlg,
                    breakfastTsukiFlg: membershipReserveInfo.breakfastTsukiPlanFlg,
                    thanksFlg: membershipReserveInfo.thanksFlg,
                    registFlg: true,
                    applicantFlg: inputUserInfo.applicantFlg,
                    userInfo,
                }

                common.doPost(changeReserve, req, afterSetReserve);
            } else {
                // const mealFlg = membershipReserveInfo.planCd &&
                //     (membershipReserveInfo.breakfastTsukiPlanFlg || membershipReserveInfo.dinnerTsukiPlanFlg || membershipReserveInfo.thanksFlg ||
                //         membershipReserveInfo?.planCategoryDetailCd == Const.TRAVEL_SUPPORT_CODE);
                // リクエスト設定
                req = {
                    shisetsuCd: membershipReserveInfo.shisetsuCd,
                    keiyakuNo: membershipSearchParam.keiyakuNo,
                    riyoKaiinkenSyubetCd: membershipSearchParam.riyoKaiinkenSyubetCd,
                    pointKaiinId: membershipSearchParam.memberCd,
                    riyoDate: membershipSearchParam.checkInDate,
                    hakuCnt: membershipSearchParam.nights,
                    planCd: membershipReserveInfo.planCd,
                    // planCd: mealFlg ? membershipReserveInfo.planCd : null,
                    planShohinCd: membershipReserveInfo.planShohinCd,
                    planCategoryDetailCd: membershipReserveInfo.planCategoryDetailCd,
                    foodRequest: inputUserInfo.foodRequest,
                    allergyKbn: inputUserInfo.allergyKbn,
                    allergyBiko: inputUserInfo.allergyBiko,
                    applicantNameKana: inputUserInfo.applicantNameKana,
                    applicantName: inputUserInfo.applicantName,
                    daihyouNameKana: inputUserInfo.daihyouNameKana,
                    daihyouName: inputUserInfo.daihyouName,
                    mainPhoneKbn: inputUserInfo.mainPhoneKbn,
                    mainPhoneNumber: inputUserInfo.mainPhoneNumber,
                    contactPhoneNumber: inputUserInfo.contactPhoneNumber,
                    contactMailAddress: inputUserInfo.contactMailAddress,
                    relationCd: inputUserInfo.relationCd,
                    prefectureCd: inputUserInfo.prefectureCd,
                    prefecture: inputUserInfo.prefecture,
                    zipCode1: inputUserInfo.zipCode1,
                    zipCode2: inputUserInfo.zipCode2,
                    address1: inputUserInfo.address1,
                    address2: inputUserInfo.address2,
                    address3: inputUserInfo.address3,
                    transportCd: inputUserInfo.transportCd,
                    carCnt: inputUserInfo.carCnt,
                    busTime: inputUserInfo.busTime,
                    kozafurikaeFlg: inputUserInfo.kozafurikaeFlg,
                    smartCheckInFlg: inputUserInfo.smartCheckInFlg,
                    smartCheckOutFlg: inputUserInfo.smartCheckOutFlg,
                    nonstopCheckInFlg: inputUserInfo.nonstopCheckInFlg,
                    biko: inputUserInfo.biko,
                    kakuninMailKiboKbn: inputUserInfo.kakuninMailKiboKbn ? "1" : "0",
                    kakuninMailAddress: inputUserInfo.confirmReserveMail,
                    machiFlg: inputUserInfo.machiFlg,
                    roomList: inputUserInfo.roomList,
                    foodList: inputUserInfo.foodList,
                    foodCourseList: inputUserInfo.foodCourseList,
                    shokaKenriList: reqShokaKenriList,
                    importedFlg: membershipReserveInfo.generalFlg,
                    dinnerTsukiFlg: membershipReserveInfo.dinnerTsukiPlanFlg,
                    breakfastTsukiFlg: membershipReserveInfo.breakfastTsukiPlanFlg,
                    thanksFlg: membershipReserveInfo.thanksFlg,
                    registFlg: true,
                    applicantFlg: inputUserInfo.applicantFlg,
                    userInfo,
                }

                common.doPost(setReserve, req, afterSetReserve);

                if (inputUserInfo.saveHomeFlInfoFlg) {
                    requestRegistSaveHomeFlInfo();
                }
            }
        }
    }

    // 「ホームFLの利用」の保存処理
    const requestRegistSaveHomeFlInfo = () => {
        const req = {
            memberCode: membershipSearchParam.memberCd,
            membershipNo: membershipSearchParam.kaiinkenNo,
            usedHomeFlKenriFlg: inputUserInfo.usedHomeFlKenriFlg
        }
        common.doPost(registSaveHomeFlInfo, req, afterHomeFlInfoAdd);
    };

    // 「ホームFLの利用」の保存後処理
    const afterHomeFlInfoAdd = (res) => {
        return;
    }

    // 同意情報表示
    const onClickDoiTitle = (mealIndx, doiIndex) => {
        let doiInfo = mealInfoList[mealIndx].doiList[doiIndex]
        setPopupData('', 'doiInfo', { doiInfo });
    }

    return (
        <div className="userInputInnerWrapper">
            <BreadCrumb
                breadCrumbStyle={isWideTablet ? { display: "none" } : styles.breadCrumb}
                linkStyle={styles.link}
                linkList={linkList}
                lastLabel="入力内容確認"
                lastLabelClassName="lastLabel"
            />
            <div style={isWideTablet ? styles.breadCrumb2 : { display: "none" }}></div>
            {illegalFlg ?
                <div className="reserveInputWrapper">
                    <Label
                        label={MessageConst.ILLEGAL_ACCESS_ERROR}
                        style={styles.errorDiv}
                    />
                </div>
                :
                <>
                    <div className="reserveInputWrapper">
                        <Label
                            label={MessageConst.NOT_YET_COMPLETED_MESSAGE}
                            style={styles.notYetCompleted}
                        />
                        <Label
                            label={isWideTablet ? MessageConst.CONFIRM_MESSAGE_SP : MessageConst.CONFIRM_MESSAGE}
                            className="confirmMessage"
                        />
                        <div className={"reserveInfo"}>
                            <Label
                                label={"ご予約内容"}
                                className="reserveInfoTitle"
                            />
                            <div className={"inputUserWrap"}>
                                <div className="reserveInfoContentBlock">
                                    <div className="reserveInfoContent">
                                        <Label
                                            label="ホテル名"
                                            className="reserveInfoTitleGray"
                                        />
                                        <Label
                                            label={membershipReserveInfo.shisetsuName}
                                            className="confirmContentLabel"
                                        />
                                    </div>
                                </div>
                                <div className="reserveInfoContentBlock">
                                    <div className="reserveInfoContent">
                                        <Label
                                            label="チェックイン"
                                            className="reserveInfoTitleGray"
                                        />
                                        <Label
                                            label={commonUtil.getStringFromDateJpnMembership(membershipSearchParam.checkInDate)}
                                            className="confirmContentLabel"
                                        />
                                    </div>
                                    <div className="reserveInfoContent">
                                        <Label
                                            label="チェックアウト"
                                            className="reserveInfoTitleGray"
                                        />
                                        <Label
                                            label={commonUtil.getStringFromDateJpnMembership(membershipSearchParam.checkOutDate)}
                                            className="confirmContentLabel"
                                        />
                                    </div>
                                    <div className="reserveInfoContent">
                                        <Label
                                            label=""
                                            className="reserveInfoTitleGray"
                                        />
                                        <Label
                                            label={membershipSearchParam.nights + "泊"}
                                            className="confirmContentLabel"
                                        />
                                    </div>
                                </div>
                                <div className="reserveInfoContentBlock">
                                    <div className="reserveInfoContent">
                                        <Label
                                            label="室数"
                                            className="reserveInfoTitleGray"
                                        />
                                        <Label
                                            label={membershipSearchParam.roomCnt + "室"}
                                            className="confirmContentLabel"
                                        />
                                    </div>
                                </div>
                                <div className="reserveInfoContentBlock">
                                    <div className="reserveInfoContent">
                                        <Label
                                            label="宿泊プラン名"
                                            className="reserveInfoTitleGray"
                                        />
                                        <div className="confirmContentLabel">
                                            <div>
                                                <Label
                                                    label={membershipReserveInfo.machiFlg === "1" ? "交換待ち" : membershipReserveInfo.machiFlg === "2" ? "キャンセル待ち" : membershipReserveInfo.planName}
                                                />
                                                <Label
                                                    label={(membershipReserveInfo.dinnerRyokinAdult ? "夕食￥" + membershipReserveInfo.dinnerRyokinAdult.toLocaleString() + "　" : "") + (membershipReserveInfo.breakfastTsukiFlg ? "朝食付き" : "")}
                                                />
                                            </div>
                                            <img
                                                src={thanks_logo}
                                                style={membershipReserveInfo.thanksFlg ? { height: "40px" } : { display: "none" }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="reserveInfoContentBlock lastContent">
                                    <div className="reserveInfoContent">
                                        <Label
                                            label="会員番号"
                                            className="reserveInfoTitleGray"
                                        />
                                        <Label
                                            label={membershipSearchParam.kaiinkenNo}
                                            className="confirmContentLabel"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* 部屋情報入力フォーム */}
                    <RoomInputList
                        roomList={inputUserInfo.roomList ? inputUserInfo.roomList : []}
                        roomTypeList={roomTypeList}
                        id={props.id}
                        titleClassName="titleLabel"
                        flgList={flgList}
                        responsiveFlg={isWideTablet}
                        confirmFlg={true}
                    />
                    {/* 食事情報入力フォーム */}
                    <MealInputList
                        mealList={mealInfoList ? mealInfoList : []}
                        otherMenuList={otherMenuInfoList ? otherMenuInfoList : []}
                        inputUserInfo={inputUserInfo ? inputUserInfo : {}}
                        reserveInfo={membershipReserveInfo ? membershipReserveInfo : []}
                        rightInfo={right}
                        jikantaiKbnList={jikantaiKbnList}
                        titleClassName="titleLabel"
                        flgList={flgList}
                        responsiveFlg={isWideTablet}
                        machiFlg={membershipReserveInfo.machiFlg}
                        generalFlg={membershipReserveInfo.generalFlg}
                        thanksFlg={membershipReserveInfo.thanksFlg}
                        onClickOpenPopupWindow={onClickOpenPopupWindow}
                        onClickDoiTitle={onClickDoiTitle}
                        confirmFlg={true}
                        totalPrice={totalPrice}
                    />
                    <div className="btnToConfirmWrapper">
                        <div class="confirmboxWrap">
                            <Button buttonText="戻る" className="btnBack btnSpStyle" onClick={onClickBack} buttonClassName="serachBtnText" />
                            <Button buttonText="この内容で予約する" className="btnReserveOrCredit" onClick={onClickReserve} buttonClassName="serachBtnText" />
                        </div>
                    </div>
                </>
            }
            <div className="backTopInputUser">
                <Link to={loginType === 'MEMBER' ? "/reserve/hotel/search" : "/reserve/hotel/crawlSearch"} style={styles.bottomLink}>ホテル検索TOPへ戻る</Link>
                <div style={errorInfo.errorFlg ? styles.errorDiv : { display: "none" }}>
                    <ErrorMassage style={styles.errorMassage} data={errorInfo.errorMessage} />
                </div>
            </div>
            <div style={styles.footer}>
                <MembershipFooterContainer className={"reservationResultFooterBase"} />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        login: state.login,
        membershipSearchParam: state.membershipSearchParam,
        inputUserInfo: state.inputUserInfo,
        membershipReserveInfo: state.membershipReserveInfo,
        mealInfoList: state.mealInfoList,
        otherMenuInfoList: state.otherMenuInfoList,
        right: state.right
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setMealInfoList: (item) => {
            dispatch({ type: "MEAL_INFO_LIST", payload: { mealInfoList: item } })
        },
        setOtherMenuInfoList: (item) => {
            dispatch({ type: "OTHER_MENU_INFO_LIST", payload: { otherMenuInfoList: item } })
        },
        setMembershipSearchParam: (item) => {
            dispatch({ type: "MEMBERSHIP_SEARCH_PARAM", payload: { membershipSearchParam: item } })
        },
        setInputUserInfo: (item) => {
            dispatch({ type: "INPUT_USER_INFO", payload: { inputUserInfo: item } })
        },
        setMembershipReserveInfo: (item) => {
            dispatch({ type: "MEMBERSHIP_RESERVE_INFO", payload: { membershipReserveInfo: item } })
        },
        setMembershipReserveComf: (item) => {
            dispatch({ type: "MEMBERSHIP_RESERVE_COMF", payload: { membershipReserveComf: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(MembershipConfirmUserContainer);

const styles = {
    breadCrumb: {
        display: "flex",
        color: "white",
        padding: "8px 0px 30px 0px",
    },
    breadCrumb2: {
        marginBottom: "30px",
    },
    userInput: {
        display: "block",
        flexWrap: "wrap",
    },
    link: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    bottomLink: {
        padding: "3px",
        color: "#696969",
        fontSize: "small",
    },
    errorMassage: {
        display: "inline-block",
        textAlign: "left",
        padding: "15px 0px 0px 0px",
    },
    errorDiv: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        background: "rgba(255,255,255,0)",
        border: 0,
        fontWeight: "bold"
    },
    notYetCompleted: {
        color: "red",
        fontSize: "12.8px",
        letterSpacing: "2px",
        paddingBottom: "10px",
        fontWeight: "bold",
        textAlign: "center",
    },
}
